import appConfig from '../../config';
import "select2/dist/js/i18n/cs";

export default class Select2Component {
	constructor() {
		this.init();
	}

	init() {
		const selects = document.querySelectorAll('select[data-provide="select2"]:not([data-select2-init="1"])');
		selects.forEach((item) => this.initializeSelect(item));
	}

	initializeSelect(item) {
		item.setAttribute('data-select2-init', "1");

		const sortAsc = !item.hasAttribute('data-select2-sort') || item.getAttribute('data-select2-sort') === 'asc';

		let config = this.getDefaultConfig(sortAsc);

		const customConfig = item.getAttribute('data-select2-config');
		if (customConfig) {
			config = this.mergeConfigs(config, JSON.parse(customConfig));
		}

		const select2Instance = this.initializeSelect2(item, config);

		if (!item.getAttribute('multiple')) {
			this.attachChangeEvent(select2Instance, item);
		}
	}

	getDefaultConfig(sortAsc) {
		return {
			ajax: {
				dataType: 'json',
				delay: 250,
				data: (params) => ({
					q: params.term || ''
				}),
				processResults: (payload) => {
					if (!payload.results || payload.results.length === 0) {
						return null;
					}

					return {
						results: payload.results,
						more: false
					};
				},
				cache: true
			},
			language: appConfig.locale,
			dropdownAutoWidth: true,
			minimumResultsForSearch: 20,
			allowClear: true,
			sorter: (data) => data.sort((a, b) => {
				if (a.text > b.text) return sortAsc ? 1 : -1;
				if (a.text < b.text) return sortAsc ? -1 : 1;
				return 0;
			})
		};
	}

	mergeConfigs(defaultConfig, customConfig) {
		return {...defaultConfig, ...customConfig};
	}

	initializeSelect2(item, config) {
		return $(item).select2(config);
	}

	attachChangeEvent(select2Instance, item) {
		$(select2Instance).on('select2:select', (e) => {
			const event = new Event('change');
			Object.defineProperty(event, 'target', {writable: false, value: e.target});
			item.dispatchEvent(event);
		});
	}
}